var exports = {
  "k": "x127c5a35--8897c2--container",
  "V": "x127c5a35--8897c2--empty_photo",
};

module.exports = exports;
